import { Container } from '../ui/Container'
import { Eyebrow } from '../ui/Eyebrow'
import { Reveal } from '../ui/Reveal'
import { testimonials } from '../../data/testimonials'

export function Testimonials() {
  return (
    <section className="border-b border-ink/10 py-24 md:py-32">
      <Container>
        <Reveal>
          <Eyebrow>Feedback</Eyebrow>
          <h2 className="mt-6 max-w-2xl font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-5xl">
            Early results, real feedback
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-graphite">
            Before Limitlast became a technology company, we delivered real outcomes for real
            clients — feedback that still shapes how we build today.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-6 sm:grid-cols-2">
          {testimonials.map((testimonial, i) => (
            <Reveal key={testimonial.name} delay={i * 100}>
              <figure className="flex h-full flex-col justify-between rounded-3xl bg-bone p-8 md:p-10">
                <span aria-hidden="true" className="font-display text-4xl text-signal">
                  &ldquo;
                </span>
                <blockquote className="mt-4 flex-1 text-base leading-relaxed text-ink/90">
                  {testimonial.quote}
                </blockquote>
                <figcaption className="mt-8 text-sm font-medium text-ink/70">
                  — {testimonial.name}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}
